<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-text">充值总人数：<span>{{statisticsInfo.count_all}}</span></div>
      <div class="v-text">充值总金额：<span>￥{{statisticsInfo.amout_all}}</span></div>
      <div class="v-text">本月新增充值：<span>{{statisticsInfo.count_month}}</span></div>
      <div class="v-text">本月充值金额：<span>￥{{statisticsInfo.amout_month}}</span></div>
      <div class="v-text">今日新增充值：<span>{{statisticsInfo.count_today}}</span></div>
      <div class="v-text">今日充值金额：<span>￥{{statisticsInfo.amout_today}}</span></div>
      <!-- <div class="v-text">实际充值：<span>￥{{statisticsInfo.total}}</span></div>
      <div class="v-text">充值总额（充值赠送<span>0</span>）：<span>￥24628</span></div>
      <div class="v-text">已消费：<span>￥248</span></div> -->
    </div>
    <div class="search-container">
      <div class="v-search-btn">
        <el-date-picker value-format="yyyy-MM-dd" class="v-date" v-model="valuedate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <el-input style="margin-left:16px;" v-model="valueid" clearable placeholder="请输入用户ID/手机号"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
      </div>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" width="250px" label="会员">
              <template slot-scope="scope">
                <div class="pay-member-photo">
                  <img :src="scope.row.member_wxheadurl" />
                </div>
                <div v-if="scope.row.name!==''" class="pay-member-name">{{ scope.row.member_name }}<br />ID：{{ scope.row.member_mid }}</div>
                <div v-else class="pay-member-name">{{ scope.row.member_wxname }}<br />ID：{{ scope.row.member_mid }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="充值方式">
              <template slot-scope="scope">
                <span>{{ changeRechargeType(scope.row.rechargetype)}} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="实际充值">
              <template slot-scope="scope">
                <span>￥{{ scope.row.amount }} </span>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="充值+赠送">
              <template slot-scope="scope">
                <span>￥{{ totalRecharge(scope.row.amount,scope.row.prize) }} </span>
              </template>
            </el-table-column> -->
            <el-table-column align="center"  label="是否已退款">
              <template slot-scope="scope">
                <span>{{ refundedChange(scope.row.refunded) }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="充值后余额">
              <template slot-scope="scope">
                <span>￥{{scope.row.balance}} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="160px" label="充值时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createtime}} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="备注">
              <template slot-scope="scope">
                <span>{{ scope.row.remark}} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="250px" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleRemark(scope.row)" type="primary" size="mini">
                  <span v-if="scope.row.remark===''">添加备注</span>
                  <span v-if="scope.row.remark!==''">修改备注</span>
                </el-button>
                <el-button @click="handleRefundffirm(scope.row)" type="danger" size="mini">
                  <span>退 款</span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" :page-size="pageSize" layout="prev, pager, next" :current-page="page" :total="total">
      </el-pagination>
    </el-container>
    <el-dialog title="添加备注" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-input type="textarea" v-model="desc"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleAffirm">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import {
  searchRechargeList,
  setRechargeRemark,
  rechargeStatistics,
  handleRefund
} from '@/views/webpc/CashierDesk/RechargeRecordApp/apis'
export default {
  data () {
    return {
      isLoading: false,
      tableData: [],
      page: 1,
      pageSize: 20,
      total: 0,
      dialogVisible: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      valuedate: null,
      valueid: '',
      desc: '',
      params: {},
      statisticsInfo: {}
    }
  },
  methods: {
    // 实际加赠送
    totalRecharge (amount, prize) {
      let total = parseFloat(amount) + parseFloat(prize)
      return total.toFixed(2)
    },
    // 充值方式转换
    changeRechargeType (status) {
      status = parseInt(status)
      switch (status) {
        case 0:
          return '在线充值'
        case 1:
          return '现金'
        case 2:
          return '刷卡'
        case 3:
          return '其他'
        default:
          return '其他'
      }
    },
    // 是否已退款
    refundedChange (status) {
      status = parseInt(status)
      switch (status) {
        case 0:
          return '未退款'
        case 1:
          return '已退款'
        default:
          return '其他'
      }
    },
    // 充值记录
    loadData () {
      this.isLoading = true
      this.tableData = []
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      data.append('keywords', this.valueid)
      if (this.valuedate) {
        data.append('startdate', this.valuedate[0])
        data.append('enddate', this.valuedate[1])
      }
      searchRechargeList(data)
        .then((result) => {
          if (result) {
            this.isLoading = false
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        })
        .catch((error) => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    },
    handleClose () {
      this.params = {}
      this.desc = ''
      this.dialogVisible = false
    },
    handleRemark (params) {
      this.params = params
      this.desc = params.remark
      this.dialogVisible = true
    },
    handleAffirm () {
      let data = new FormData()
      data.append('id', this.params.id)
      data.append('remark', this.desc)
      setRechargeRemark(data)
        .then((result) => {
          if (result) {
            this.dialogVisible = false
            this.loadData()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
        .catch((error) => {
          if (error) {
          }
        })
    },
    // 充值统计
    getRechargeStatistics () {
      rechargeStatistics().then((result) => {
        if (result) {
          this.statisticsInfo = result.data
        }
      })
    },
    // 退款金额
    getHandleRefund (params) {
      let data = new FormData()
      data.append('id', params.id)
      data.append('key', params.amount)
      handleRefund(data).then((result) => {
        if (result) {
          this.loadData()
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        }
      })
    },
    // 退款触发
    handleRefundffirm (params) {
      this.$confirm('确认全额退款, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.getHandleRefund(params)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      // this.$prompt('请输入金额', '退款金额', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputPattern: /^([1-9]\d*(\.\d*)?)$|^0\.\d*[1-9]\d*$/,
      //   inputErrorMessage: '金额格式不正确'
      // }).then(({ value }) => {
      //   this.getHandleRefund(value, id)
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '取消输入'
      //   })
      // })
    }
  },
  mounted () {
    this.getRechargeStatistics()
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/RechargeRecordApp/RechargeRecord.vue